import { render, staticRenderFns } from "./DiscoverDetailDeleivery.vue?vue&type=template&id=604b2e17&scoped=true&"
import script from "./DiscoverDetailDeleivery.vue?vue&type=script&lang=js&"
export * from "./DiscoverDetailDeleivery.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverDetailDeleivery.vue?vue&type=style&index=0&id=604b2e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b2e17",
  null
  
)

export default component.exports